import React from 'react';
import Navbar from '../components/Navbar';
import '../App.css';
import './HIPAA.css';

const HIPAA = () => {
  return (
    <div className="App">
      <Navbar />
      <main className="hipaa-container">
        <section className="hipaa-hero">
          <h1>HIPAA Notice of Privacy Practices</h1>
          <p className="hipaa-subtitle">
            This notice explains how your medical information may be used and shared, and how you can access it. 
            <span className="highlight">Please read it carefully.</span>
          </p>
        </section>
        
        <section className="hipaa-content">
          <div className="hipaa-section">
            <h2>Our Commitment to Your Privacy</h2>
            <p>
              We are dedicated to protecting your medical information. By law, we must:
            </p>
            <ul className="commitment-list">
              <li>Keep your medical information private</li>
              <li>Give you this notice explaining our privacy practices</li>
              <li>Follow the terms of the notice currently in effect</li>
            </ul>
          </div>

          <div className="hipaa-section">
            <h2>How We May Use & Share Your Medical Information</h2>
            
            <div className="info-use">
              <h3>1. Treatment</h3>
              <p>We may use or share your information to provide and coordinate your care.</p>
              <p className="example">Example: Sharing information with a specialist involved in your treatment.</p>
            </div>
            
            <div className="info-use">
              <h3>2. Payment</h3>
              <p>We may use or share your information to bill you, your insurance, or another payer.</p>
              <p className="example">Example: Sending information to your health plan so your visit can be reimbursed.</p>
            </div>
            
            <div className="info-use">
              <h3>3. Health Care Operations</h3>
              <p>We may use your information for daily operations, such as quality reviews, staff training, or improving care.</p>
            </div>
            
            <div className="info-use">
              <h3>4. Appointment Reminders & Care Updates</h3>
              <p>We may contact you with reminders, follow-up instructions, or updates about treatment options or services.</p>
            </div>
            
            <div className="info-use">
              <h3>5. People Involved in Your Care</h3>
              <p>We may share limited information with family or friends involved in your care, unless you ask us not to.</p>
            </div>
            
            <div className="info-use">
              <h3>6. When Required or Allowed by Law</h3>
              <p>We may disclose information in situations such as:</p>
              <ul>
                <li>Preventing a serious health or safety threat</li>
                <li>Public health reporting (disease, abuse, emergencies)</li>
                <li>Workers' compensation cases</li>
                <li>Court orders or legal requests</li>
                <li>Organ donation processes</li>
                <li>Coroners or medical examiners</li>
                <li>Military or national security activities</li>
              </ul>
              <p>We always follow state and federal confidentiality laws, including stricter protections for certain types of sensitive information.</p>
            </div>
            
            <div className="info-use">
              <h3>7. Uses Requiring Your Written Permission</h3>
              <p>We will not use or share your medical information for purposes not listed above unless you give us written authorization.</p>
              <p>You may cancel that authorization at any time (except for information already used or shared).</p>
            </div>
          </div>

          <div className="hipaa-section">
            <h2>Your Rights</h2>
            <p>You have the right to:</p>
            
            <div className="rights-list">
              <h3>1. Access Your Records</h3>
              <p>Request to see or get a copy of your medical information in paper or electronic form.</p>
              
              <h3>2. Request Corrections</h3>
              <p>Ask us to correct or add information if you believe it is incomplete or inaccurate.</p>
              
              <h3>3. Request a List of Disclosures</h3>
              <p>Ask for a list of when we shared your medical information (other than for treatment, payment, or operations).</p>
              
              <h3>4. Request Restrictions</h3>
              <p>Ask us to limit how we use or share your information.</p>
              <p>We must honor requests to not share information with your health plan if you paid for the service in full.</p>
              
              <h3>5. Request Confidential Communications</h3>
              <p>Ask us to contact you in a specific way or at a specific location (e.g., only at work or by mail).</p>
              
              <h3>6. Receive a Paper Copy</h3>
              <p>You may request a paper copy of this notice at any time.</p>
              
              <h3>7. File a Complaint</h3>
              <p>If you feel your privacy rights were violated, you may file a complaint with:</p>
              <ul>
                <li>Aspen Quick Care (see contact info below)</li>
                <li>The U.S. Department of Health and Human Services</li>
              </ul>
              <p>You will not be punished for filing a complaint.</p>
            </div>
          </div>

          <div className="hipaa-section">
            <h2>Changes to This Notice</h2>
            <p>We may update this notice at any time. The newest version will always be available at our clinic and on our website.</p>
          </div>

          <div className="contact-section">
            <h2>Contact Us</h2>
            <p>If you have questions or want to exercise your privacy rights, please contact:</p>
            <address>
              <strong>Aspen Quick Care – Privacy Office</strong><br />
              Email: <a href="mailto:bettercare@aspenquickcare.com" className="email-link">bettercare@aspenquickcare.com</a>
            </address>
          </div>
        </section>
      </main>
    </div>
  );
};

export default HIPAA;
